import * as React from "react";

const invoiceButton = (showInvoiceButton, handleInvoice) =>
  showInvoiceButton ? (
    <button className="btn btn-success" onClick={handleInvoice}>
      Pay by invoice
    </button>
  ) : null;

const OrderForm = function(props) {
  return (
    <form className="form-inline" onSubmit={props.handleSubmit}>
      <div className="form-group">
        <label className="mb-2 mr-sm-2 mb-sm-0" htmlFor="order_quantity">
          Quantity
        </label>
        <div className="input-group">
          <input
            className="form-control"
            id="order_quantity"
            required="required"
            step="1"
            min="1"
            max="5000"
            type="number"
            value={props.quantity}
            name="order[quantity]"
            onChange={props.updateAmount}
          />
          <span className="input-group-btn">
            <input
              type="submit"
              value={props.buttonText}
              className="btn btn-success"
              disabled={props.disabled}
            />

            {invoiceButton(props.showInvoiceButton, props.handleInvoice)}
          </span>
        </div>
      </div>
    </form>
  );
};

export default OrderForm;
